import { useEffect } from "react";
import { buildOfferClickUrl } from "../../utils/offerUrl";

export const Installed = () => {
  const param = new URLSearchParams(document.location.search);

  let pixel = param.get("pixel");
  if (!pixel) {
    pixel = localStorage.getItem("pixel");
  }

  useEffect(() => {
    localStorage.removeItem("isClickedInstall");

    const offerUrl = buildOfferClickUrl();

    const sendPixel = () => {
      if (localStorage.getItem("pixelUsed")) {
        return;
      }
      const el = document.getElementById("pixelTagId");
      if (el && pixel) {
        /* global fbq */
        // eslint-disable-next-line
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = "2.0";
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(
          window,
          document,
          "script",
          "https://connect.facebook.net/en_US/fbevents.js"
        );
        fbq("init", pixel);
        fbq("track", "Lead");
        el.innerHTML = `<img alt='test' src=https://www.facebook.com/tr?id=${pixel}&ev=PageView&noscript=1 style="display:none" width="1px" height="1px">`;
      }
      localStorage.setItem("pixelUsed", true);
    };

    sendPixel();

    setTimeout(() => {
      window.location.href = offerUrl;
    }, 2000);
  }, []);

  return (
    <>
      <div id="pixelTagId"></div>
      <div className="loader"></div>
    </>
  );
};
